.description-text{height:100%;font-size:16px;font-weight:700}.action-button{margin-top:15%}
/*# sourceMappingURL=account-disabled.component-BA64ARYW.css.map */
